module.exports = __webpack_public_path__ + "assets/urendeclareren3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/documentation/images/urendeclareren3.jpg
// module id = 368
// module chunks = 0